import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import IntroField, { IIntroFieldProps } from "../Components/IntroField";

/** A Text Field for gathering the Postal Code.
 * Controlled from the Session Context.
 */
const SessionContextZipCodeField = SessionContextValueProvider({
  Component: IntroField,
  map: ({ unverifiedCustomer, setCustomer, setUnverifiedCustomer }) => {
    return {
      value: unverifiedCustomer.zipCode,
      onChangeValue: (zipCode: string) => setUnverifiedCustomer(c => ({ ...c, zipCode: zipCode })),
      onChange: (zipCode: string) => setCustomer(c => ({ ...c, zipCode: zipCode }))
    } as IIntroFieldProps;
  }
});

export default SessionContextZipCodeField;
